import React from 'react';
import classNames from 'classnames';
import {
  COLOR_MAP_BY_STATUS,
  NEUTRAL_CLASSNAMES,
  STATUSES_FOR_COLORS
} from 'constants/colors';

export default function StatusCell({ status = STATUSES_FOR_COLORS.DEFAULT, ...props }) {
    const spanClassNames = classNames(
      'inline-flex rounded-full px-2 text-xs font-semibold leading-5 ring-1 ring-inset',
      COLOR_MAP_BY_STATUS[status] || NEUTRAL_CLASSNAMES,
      props.className
    );

  return (
    <span className={spanClassNames}>
      {status}
    </span>
  );
}